import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {DecisionType} from "../backend/entity/elective/Choice";

export interface ElectiveCourseSemestersInfo {
    courseId: number
    selectedSemesters: string[]
}

export interface ElectiveChoice {
    specialityId: number
    courseId: number
    courseEcts: number
    decision: DecisionType
    electiveGroup: string
}


export interface ElectiveCoursesState {
    electiveChoices: ElectiveChoice[]
}

const electiveCoursesInitialState: ElectiveCoursesState = {
    electiveChoices: []
}

const electiveCoursesSlice = createSlice({
    name: 'elective_courses',
    initialState: electiveCoursesInitialState,
    reducers: {
        addElectiveChoices(state, action: PayloadAction<ElectiveChoice[]>) {
            action.payload.map(nec => {
                if (!state.electiveChoices.find(ec =>
                    (ec.courseId === nec.courseId
                        && ec.electiveGroup.toLowerCase() === nec.electiveGroup.toLowerCase()
                        && ec.specialityId === nec.specialityId))) {
                    state.electiveChoices.push(nec)
                }
                return state.electiveChoices
            })
        },
        removeElectiveChoices(state, action: PayloadAction<ElectiveChoice[]>) {
            action.payload.map(nec => {
                if (state.electiveChoices.find(ec => (ec.courseId === nec.courseId
                    && ec.electiveGroup.toLowerCase() === nec.electiveGroup.toLowerCase()
                    && ec.specialityId === nec.specialityId
                ))) {
                    state.electiveChoices = state.electiveChoices.filter((e) => !(e.courseId === nec.courseId
                        && e.electiveGroup.toLowerCase() === nec.electiveGroup.toLowerCase()
                        && e.specialityId === nec.specialityId
                    ))
                }
                return state.electiveChoices
            })
        },
    }
})

export const {addElectiveChoices, removeElectiveChoices} = electiveCoursesSlice.actions
export default electiveCoursesSlice.reducer